import flatpickr from "flatpickr"
import { qsa } from "./utils.js"
import "../../node_modules/flatpickr/dist/flatpickr.min.css"
import { German } from "flatpickr/dist/l10n/de.js"

flatpickr.localize(German)

let _configurableEditorPromise
function createConfigurableEditor(textarea) {
  if (!_configurableEditorPromise) {
    _configurableEditorPromise = import("django-prose-editor/configurable")
  }

  _configurableEditorPromise.then(({ createEditor }) => {
    createEditor(textarea)
  })
}

const _doInit = (el) => {
  const defaults = {
    altInput: true,
    static: true,
    time_24hr: true,
  }
  const pickers = {}
  const stripPrefix = (name) => name.split("-").at(-1)

  for (const el of qsa('input[type="date"]')) {
    if (el.closest("rrule-widget")) {
      // Hack: It doesn't look nice and doesn't play that well with the web component.
      continue
    }

    pickers[stripPrefix(el.name)] = flatpickr(el, {
      ...defaults,
      altFormat: "j. F Y",
      dateFormat: "Y-m-d",
    })
  }

  for (const el of qsa('input[type="datetime-local"]')) {
    pickers[stripPrefix(el.name)] = flatpickr(el, {
      ...defaults,
      altFormat: "j. F Y H.i",
      dateFormat: "Y-m-dTH:i",
      enableTime: true,
    })
  }

  if (pickers.date_from && pickers.date_until) {
    pickers.date_until.set("minDate", pickers.date_from.selectedDates[0])
    pickers.date_from.config.onChange.push((selectedDates) => {
      pickers.date_until.set("minDate", selectedDates[0])
    })
  }

  const marker = "data-django-prose-editor-default"
  for (const textarea of qsa(`[${marker}]`, el)) {
    window.DjangoProseEditor.createEditor(textarea)
  }

  for (const textarea of qsa("[data-django-prose-editor-configurable]", el)) {
    createConfigurableEditor(textarea)
  }
}

export const initWidgets = () => {
  _doInit()

  document.addEventListener("dialog:show", (e) => {
    console.debug("dialog:show", { e })
    _doInit(e.detail)
  })

  document.addEventListener("htmx:afterSwap", (details) => {
    _doInit(details.elt)
  })

  document.addEventListener("htmx:beforeSwap", () => {
    const dateInputs = qsa('input[type="date"], input[type="time"]')
    for (const input of dateInputs) {
      const clone = input.cloneNode(true)
      input.replaceWith(clone)
    }
  })
}
